module.exports = __webpack_public_path__ + "static/media/3_n.e216259f.jpg";